<template>
    <div id="visitor-detail-page">
        <AppBreadCrumb
            :paths="[{ title: $t('visitor.visitorDetail') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>
        <VisitorDetail :visitorId="visitorId" :visibleMail="false"/>
    </div>
</template>
<script>
import VisitorDetail from "./Visitors/VisitorDetail.vue";
import AppBreadCrumb from "../../components/common/AppBreadCrumb.vue";
export default {
    name: "VisitorDetailPage",
    components: {
        VisitorDetail,
        AppBreadCrumb,
    },
    props: {
        visitorId: {
            type: String,
            default: "",
        },
    },
}
</script>
<style>

</style>
